module.exports = __webpack_public_path__ + "img/logo.41f08f81.png";